import { Layout } from "@/components/layout";
import { About, Guide, Home, Location, Rooms, Specials } from "@/domains";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/home",
                element: <Home />,
            },
            {
                path: "/location",
                element: <Location />,
            },
            {
                path: "about",
                element: <About />,
            },
            {
                path: "/rooms/:roomIdx",
                element: <Rooms />,
            },
            {
                path: "/specials/:specialIdx",
                element: <Specials />,
            },
            {
                path: "/guide",
                element: <Guide />,
            },
        ],
    },
]);

export default router;
